import { API_BASE, buildURL, requestJSON } from "./apiClient";

// === 예측 실행 ===
export async function runPredict(payload) {
  const url = buildURL(API_BASE, "/api/predict/from-ui");
  return requestJSON(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
}

export async function getPredictMeta() {
  const url = buildURL(API_BASE, "/api/predict/meta");
  return requestJSON(url);
}

// === 결과 단건 조회 ===
export async function getPredictionById(runId) {
  const url = buildURL(API_BASE, `/api/predict/runs/${encodeURIComponent(runId)}`);
  return requestJSON(url);
}

export async function getSimilarAverage(runId) {
  const url = buildURL(API_BASE, `/api/predict/runs/${encodeURIComponent(runId)}/similar-average`);
  return requestJSON(url);
}

export async function getSimilarCases(runId, limit = 5) {
  const url = buildURL(
    API_BASE,
    `/api/predict/runs/${encodeURIComponent(runId)}/similar-cases`,
    { limit }
  );
  return requestJSON(url);
}

// 기존 이름들과 호환
export const getRunDetail = getPredictionById;
export const getPredictRun = getPredictionById;

/**
 *  예측 히스토리(검색 + 페이지네이션)
 * @param {Object} params
 * @param {string=} params.q - 프로젝트명 부분검색
 * @param {number=} params.page - 기본 1
 * @param {number=} params.page_size - 기본 20
 * @returns {Promise<{items: any[], total: number}>}
 */
export async function listPredictions(params = {}) {
  const { q, page = 1, page_size = 20 } = params;
  const url = buildURL(API_BASE, "/api/predict/history", { q, page, page_size });
  return requestJSON(url);
}

/**
 * 🧩 (구버전 호환) limit로만 부르던 호출을 page_size로 매핑
 * 기존 호출부가 listPredictionHistory({ limit: 50 })를 쓰고 있다면 그대로 동작
 */
export async function listPredictionHistory({ limit = 500 } = {}) {
  // page=1, page_size=limit 로 변환
  return listPredictions({ page: 1, page_size: limit });
}
